module.exports = __webpack_public_path__ + "assets/844268a9a83e78e8c672f1b74719b679.js";